import gql from "graphql-tag";

/**
 * Save a shipping request
 */

const SaveShippingRequest = gql`
  mutation($id: String, $data: String) {
    SaveShippingRequest(id: $id, data: $data) {
      id
      data
    }
  }
`;

export default SaveShippingRequest;
